import { default as domainArpRecords } from './records/store'

export default {
    domainArpRecords,
}
